export default {"src":"https://static.eleduck.com/_next/static/media/headhunter.d2957578.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};